import React from "react";
import { ShieldCheck, FileText, MapPin, Star, ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const trustIndicators = [{
  title: "5+ years experience",
  description: "Over five years of hands‑on home inspection experience in South Florida's unique climate and construction standards.",
  icon: ShieldCheck
}, {
  title: "50+ 5-star reviews",
  description: "Trusted by home buyers, sellers, and real estate professionals across South Florida for reliable, photo‑rich reports.",
  icon: Star
}, {
  title: "Fast report turnaround (24 hours)",
  description: "Detailed inspection reports with clear photos delivered within 24 hours—often same day.",
  icon: FileText
}, {
  title: "Experience with insurance inspections (4-point and wind mitigation)",
  description: "Specialist in wind mitigation and 4‑point inspections required for Florida homeowner's insurance.",
  icon: ClipboardCheck
}, {
  title: "Local South Florida expertise",
  description: "Understands Miami‑Dade homes, older plumbing, roofs, coastal moisture, and insurance requirements better than out‑of‑state inspectors.",
  icon: MapPin
}];
export default function WhyChooseTrustedInspections() {
  return <section id="why-choose-trusted-inspections" className="bg-background border-y border-border py-10">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {trustIndicators.map((indicator, i) => {
          const Icon = indicator.icon;
          return <div key={i} data-index={i} className="group flex flex-col items-center text-center transition-transform duration-300 hover:-translate-y-[5px]">
                <div className="relative mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-accent/50">
                  <Icon className="h-8 w-8 text-foreground stroke-[1.5]" />
                  <span className="absolute right-3 top-3 h-2.5 w-2.5 rounded-full bg-primary ring-2 ring-background" />
                </div>
                <h3 className="text-lg font-bold text-foreground leading-tight max-w-[200px]">
                  {indicator.title}
                </h3>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed max-w-[240px]">
                  {indicator.description}
                </p>
                <div className="mt-6">
                  <Button asChild variant="primary" size="sm" className="rounded-md">
                    <Link to="#">Schedule Your Inspection Today</Link>
                  </Button>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}